import React, { useState } from 'react';
import { Box, TextField, MenuItem, Alert } from '@mui/material';
import UIButton from 'components/ui/UIButton';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { feedbackActions } from 'features/feedback/store/feedback.slice';
import { collectContext } from 'features/feedback/collectContext/collectContext';
import ContextAccordion from 'features/feedback/components/ContextAccordion';
import { BugArea, BugSeverity, BUG_AREA_LABEL, SEVERITY_LABEL } from 'features/feedback/shared/feedback.types';

const BugForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const formState = useAppSelector((s) => s.feedback.formState);
  const errorMessage = useAppSelector((s) => s.feedback.errorMessage);
  const submitting = formState === 'submitting';

  const context = collectContext();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [area, setArea] = useState<BugArea>('FRONTEND');
  const [severity, setSeverity] = useState<BugSeverity>('MEDIUM');
  const [related, setRelated] = useState('');
  const [touched, setTouched] = useState(false);

  const titleErr = touched && !title.trim();
  const descErr = touched && !description.trim();
  const relatedErr = touched && area === 'CONTENT' && !related.trim();

  const onSubmit = () => {
    setTouched(true);
    if (!title.trim() || !description.trim() || (area === 'CONTENT' && !related.trim())) return;
    dispatch(
      feedbackActions.submit({
        type: 'BUG', title: title.trim(), description: description.trim(),
        bugArea: area, severity, relatedEntity: area === 'CONTENT' ? related.trim() : undefined,
        context,
      }),
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Alert icon={false} severity="info" sx={{ fontSize: 13 }}>
        🔒 Приватне — бачитимеш лише ти та адміністратор.
      </Alert>
      {formState === 'error' && <Alert severity="error">{errorMessage || 'Не вдалося надіслати. Спробуй ще раз.'}</Alert>}
      <TextField label="Коротко про проблему" value={title} onChange={(e) => setTitle(e.target.value)} error={titleErr} helperText={titleErr ? 'Додай короткий заголовок' : ''} fullWidth inputProps={{ maxLength: 200 }} />
      <TextField label="Що сталося? Що очікував(-ла)?" value={description} onChange={(e) => setDescription(e.target.value)} error={descErr} helperText={descErr ? 'Опиши проблему' : ''} multiline minRows={3} fullWidth inputProps={{ maxLength: 5000 }} />
      <TextField select label="Область" value={area} onChange={(e) => setArea(e.target.value as BugArea)} fullWidth>
        {(['BACKEND', 'FRONTEND', 'CONTENT'] as BugArea[]).map((a) => (
          <MenuItem key={a} value={a}>{BUG_AREA_LABEL[a]}</MenuItem>
        ))}
      </TextField>
      {area === 'CONTENT' && (
        <TextField label="Пов'язане слово / вправа" value={related} onChange={(e) => setRelated(e.target.value)} error={relatedErr} helperText={relatedErr ? 'Вкажи слово або вправу' : ''} fullWidth inputProps={{ maxLength: 200 }} />
      )}
      <TextField select label="Пріоритет" value={severity} onChange={(e) => setSeverity(e.target.value as BugSeverity)} fullWidth>
        {(['LOW', 'MEDIUM', 'HIGH'] as BugSeverity[]).map((s) => (
          <MenuItem key={s} value={s}>{SEVERITY_LABEL[s]}</MenuItem>
        ))}
      </TextField>
      <ContextAccordion context={context} />
      <UIButton fullWidth variant="contained" disabled={submitting} onClick={onSubmit} sx={{ mt: 1 }}>
        {submitting ? 'Надсилаємо…' : 'Надіслати'}
      </UIButton>
    </Box>
  );
};

export default BugForm;
